import { BookmarkSortModel } from '../models/bookmark-sort.model';
import { BookmarkModel } from '../models/bookmark.model';

export const bookmarkSortRelevance: BookmarkSortModel = {
    label: 'Relevance',
    fields: [],
    ascending: true
};

export const bookmarkSortRecent: BookmarkSortModel = {
    label: 'Most Recent',
    fields: ['collection_content_createdate', 'update_date_time', 'create_date_time'],
    ascending: false
};

export const bookmarkSortTitleAsc: BookmarkSortModel = {
    label: 'Title (A-Z)',
    fields: ['title'],
    ascending: true
};

export const bookmarkSortTitleDesc: BookmarkSortModel = {
    label: 'Title (Z-A)',
    fields: ['title'],
    ascending: false
};

export const bookmarkSortAuthorAsc: BookmarkSortModel = {
    label: 'Author (A-Z)',
    fields: ['author'],
    ascending: true
};

export const bookmarkSortAuthorDesc: BookmarkSortModel = {
    label: 'Author (Z-A)',
    fields: ['author'],
    ascending: false
};

export const bookmarkSortOptions: BookmarkSortModel[] = [
    bookmarkSortRelevance,
    bookmarkSortRecent,
    bookmarkSortTitleAsc,
    bookmarkSortTitleDesc,
    bookmarkSortAuthorAsc,
    bookmarkSortAuthorDesc
];
